export const emptySalvarConfiguracaoForm = {
  nome: '',
  geral: false,
  padrao: false
};

export const getSalvarConfiguracaoFormStructure = (podeSalvarGeral) => {
  const rows = [
    [
      {
        name: 'nome',
        label: 'Nome',
        component: 'FormField',
        type: 'text',
        colProps: { md: 12 },
        maxLength: 200,
        placeholder: 'Ex.: Minhas lojas SP'
      }
    ]
  ];

  const checkboxFields = [
    {
      name: 'padrao',
      label: 'Definir como configuracao padrao',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 12 }
    }
  ];

  if (podeSalvarGeral) {
    checkboxFields.unshift({
      name: 'geral',
      label: 'Configuracao geral para todos os usuarios',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 12 }
    });
  }

  rows.push(checkboxFields);

  return rows;
};

export const salvarConfiguracaoFormSections = () => [
  { title: 'Dados da configuracao', rows: [0, 1] }
];

export const validateSalvarConfiguracaoForm = (values) => {
  const errors = {};

  if (!values?.nome || !String(values.nome).trim()) {
    errors.nome = 'Nome e obrigatorio';
  }

  return errors;
};
